import React, { useEffect, useState } from "react";
import { EyeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";
import ApiCustom from "../../utils/ApiCustom";
import CustomTableComponent from "../../components/CustomTableComponent";

const animation = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  exit: { opacity: 0, y: 10, transition: { duration: 0.2 } },
};

const ProductViewCard = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    ApiCustom.get("/product-show")
      .then((res) => setProducts(res.data?.data?.product || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  // Tổng view
  const totalView = products.reduce((sum, p) => sum + (p.view || 0), 0);

  // Table header
  const headers = [
    {
      key: "urlImage",
      label: "Hình ảnh",
      render: (item) => (
        <div className="w-12 h-12 bg-gray-100 rounded flex items-center justify-center overflow-hidden">
          {item.urlImage ? (
            <img
              src={item.urlImage}
              alt={item.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-gray-300">No image</span>
          )}
        </div>
      ),
    },
    {
      key: "name",
      label: "Tên sản phẩm",
      render: (item) => (
        <span className="font-medium text-gray-900">{item.name}</span>
      ),
    },
    {
      key: "company",
      label: "Đơn vị",
      render: (item) => (
        <span className="text-gray-700">{item.company?.companyName}</span>
      ),
    },
    {
      key: "view",
      label: "Lượt xem",
      render: (item) => (
        <span className="font-bold text-blue-700">{item.view || 0}</span>
      ),
    },
  ];

  return (
    <div className="w-full">
      <motion.div
        {...animation}
        whileHover={{ scale: 1.03 }}
        className="cursor-pointer transition-all p-5 rounded-2xl bg-white border border-blue-100 shadow-md"
        onClick={() => setIsOpen(true)}
      >
        <div className="flex flex-col items-center text-center gap-2">
          <div className="p-3 bg-blue-100 rounded-full mb-1 flex items-center justify-center">
            <EyeIcon className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <p className="text-black text-lg mb-1">
              Thông tin ghé thăm sản phẩm
            </p>
            <p className="text-3xl font-bold text-black">
              {loading ? "..." : totalView}
            </p>
          </div>
        </div>
      </motion.div>

      {/* Modal: chỉ show bảng thống kê số lượng view */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            {...animation}
            className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center"
          >
            <motion.div
              {...animation}
              className="relative bg-white w-full max-w-7xl max-h-[90vh] mx-2 rounded-2xl p-7 shadow-xl overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
              >
                <XMarkIcon className="h-5 w-5" />
              </button>
              <div className="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                <h2 className="text-xl font-semibold ">
                  Thống kê lượt xem sản phẩm
                </h2>
              </div>
              {loading ? (
                <div className="text-center py-6 text-gray-400">
                  Đang tải...
                </div>
              ) : (
                <CustomTableComponent
                  headers={headers}
                  data={products}
                  className="min-w-[900px]"
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ProductViewCard;
